import Keycloak from 'keycloak-js'

const keycloakConfig = {
   url: process.env.REACT_APP_LOGIN, 
   realm: 'SingSing', 
   clientId: 'Sing-Client'
}

const keycloakLogin = keycloakConfig.url 
const keycloakLogoutPath = '/realms/'+keycloakConfig.realm+'/protocol/openid-connect/logout';
const requestParams = new window.URLSearchParams(window.location.search);
var keycloakInstance;

export function setClientId (_clientId) {
    console.log (`Set ClientId=${_clientId}, url=${keycloakConfig.url }`)
    keycloakConfig.clientId = _clientId;
}

function postEvent(message,
    targetOrigin) {
    if (window.opener) {
        window.opener.postMessage(message, targetOrigin);
    } else if (window === window.parent) {
        window.location.href = targetOrigin;
    } else {
        window.parent.postMessage(message, targetOrigin);
    }
}

export function authenticationSuccess(authenticated,
    eventType) {
    const message = { type: eventType, authenticated: authenticated };
    if (authenticated) {
        Object.assign(message, { keycloak: JSON.parse(JSON.stringify(keycloakInstance)) });
    }
    postEvent(message, requestParams.get('origin'));
}

export function authenticationError(eventType) {
    postEvent({ type: eventType, authenticated: false }, requestParams.get('origin'));
}

function buildLogoutRequestParams() {
    const baseUri = window.location.href.replace(window.location.search, '');
    const logoutRequestParams = new window.URLSearchParams();
    requestParams.append('loggedOut', 'true');
    logoutRequestParams.append('redirect_uri', baseUri + '?' + requestParams.toString());
    return logoutRequestParams.toString();
}

export function logout() {
    if (!requestParams.get('loggedOut')) {
        window.location.href = keycloakLogin + keycloakLogoutPath + '?' + buildLogoutRequestParams();
    } else {
        postEvent({ type: 'LOGOUT', authenticated: false }, requestParams.get('origin'));
    }
}

 function initKeycloak(onLoad,
    eventType,
    onSuccess,
    onError,
    silent) {
    if (!keycloakInstance) {
        keycloakInstance = new Keycloak(keycloakConfig);
    }
    keycloakInstance.init({ checkLoginIframe: false, onLoad: onLoad })
        .then(function (authenticated) {
           console.log (`keycloakInstance init authenticated: ${authenticated}`)
            if (silent === false) {
                authenticationSuccess(authenticated, eventType);
            }
            onSuccess(authenticated);
        })
        .catch(function (reason) {
            if (silent === false) {
                authenticationError(eventType);
            }
            onError(reason);
        });
}

export function login(onSuccess,
    onError) {
    const loginOptions = {};
    let idpHint = requestParams.get("kc_idp_hint");
    if (idpHint) {
        if (idpHint === 'facebook' || idpHint === 'twitter') {
            idpHint = 'sing-' + idpHint;
        }
        loginOptions.idpHint = idpHint;
    }
    keycloakInstance.login(loginOptions)
        .then(function (authenticated) {
            authenticationSuccess(authenticated, "LOGIN");
            onSuccess(authenticated);
        })
        .catch(function (reason) {
            authenticationError("LOGIN");
            onError(reason);
        });
}

/**
*
*  checkAuthenticated method to be used internally, no message will be sent to the subscriber upon authentication
*  (parent window of popup will NOT be notified)
*/
export function checkAuthenticated(onSuccess,
    onError) {
    return initKeycloak('check-sso', 'CHECK_AUTHENTICATED', onSuccess, onError, true);
}

/**
*
*  checkAuthenticated method to be used when result needs to be sent to the parent window (from popup to owner window of popup)
*
*/
export function checkAuthenticatedAndNotifyParent(onSuccess,
    onError) {
    return initKeycloak('check-sso', 'CHECK_AUTHENTICATED', onSuccess, onError, false);
}

export default  keycloakInstance